import React, { useEffect, useState } from "react";
import MainHeader from "../components/MainHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { IoWarning } from "react-icons/io5";
import MedicalReport from "../components/Report";

const ResultPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const[value,setValue] = useState(0);
  
  useEffect(() => {
    // Check if location state exists
    setValue(res[1]);
    if (!location.state || !location.state.age || !location.state.image) {
      navigate("/"); // Navigate to the landing page if state is null
      return;
    }
  }, [location.state, navigate]);

  let name = localStorage.getItem("username");
  const { age, gender, image, res } = location.state;
  const [check, setCheck] = useState(true);
  //const [value, setValue] = useState(0);

  const patientInfo = {
    name: name,
    age: age,
    gender: gender,
    score:value
  };

  const checkAnother = () => {
    navigate("/");
  };

  useEffect(() => {
    if (!res[0]) {
      setCheck(false);
      // console.log(check);
    } 
    // setValue(Math.round(res[1] * 100 * 10) / 10);
    setValue(res[1]);
    // console.log(patientInfo,gender);
  }, [res]);

  // const printPdf = () => {
  //   console.log(res);
  // };

  return (
    <div className="mt-14">
      <MainHeader />
      <div className="mx-48 mt-14">
        <h4 className="text-xpurple text-3xl font-semibold">Result</h4>
        <div className="mt-12 ml-14 flex">
          <img src={image} className="w-[280px] h-[280px] rounded-lg" alt="" />
          <div className=" ml-16 mt-6">
            {check ? (
              <h3 className="flex text-4xl font-bold text-xgreen">
                <FaCheckCircle className=" mr-6" />
                Completely OK
              </h3>
            ) : (
              <h3 className="flex text-4xl font-bold text-xred">
                <IoWarning className=" mr-6" />
                Pneumonia Detected{" "}
                <span className="text-xl pt-2 pl-2">({value}%)</span>
              </h3>
            )}

            <p className="mt-8 text-xl w-[700px] text-xgreen font-semibold">
              CheXcare uses AI to help find pneumonia in X-rays. But it may not
              be perfect, so always see a doctor for diagnosis and treatment.
              CheXcare is for info only, not a replacement for a doctor. By
              using it, you agree to these terms. If you have health concerns,
              see a doctor.{" "}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center mt-16">
        {!check && <MedicalReport patientInfo={patientInfo} />}
        <button
          onClick={checkAnother}
          className="border-2 border-xgreen w-48 py-3 rounded-3xl text-xdarkgreen"
        >
          Check Another
        </button>
      </div>
    </div>
  );
};

export default ResultPage;
